import ArrowSmall from "@/icons/arrow-small.svg";

type ButtonLinkProps = {
  label: string;
  href: string;
  external?: boolean;
};

export const ButtonLink = ({
  label,
  href,
  external = false,
}: ButtonLinkProps) => {
  return (
    <a
      className="text-report-body-small-mobile before:bg-report-grey-400/70 relative isolate flex w-full cursor-pointer items-center justify-between whitespace-nowrap border-none bg-black px-6 py-4 text-left font-mono font-medium uppercase tracking-[1.5px] text-white before:absolute before:inset-0 before:-z-20 before:origin-bottom before:scale-y-0 before:transition before:ease-in-out hover:before:scale-y-100 disabled:cursor-not-allowed disabled:opacity-50"
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
    >
      {label}
      <ArrowSmall />
    </a>
  );
};
